import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BackButtonContainer from 'components/lib/back_button_container';
import connect from 'components/lib/connect';
import CustomerView from 'models/location/customer_view';
import Floorboard from 'models/location/floorboard';
import ForgotPassword from 'models/location/forgot_password';
import Inbox from 'models/location/inbox';
import MobileBackHeader from 'components/mobile/mobile_back_header';
import MobileCustomerHeader from 'components/mobile/mobile_customer_header';
import TopBarContent from './top_bar_content';
import useDevice from 'components/hooks/use_device';
import { Device } from 'scripts/lib/device_detector';
import UserActivation from 'models/location/user_activation';
import UserLogin from 'models/location/user_login';
import UserResetPassword from 'models/location/user_reset_password';
import PaymentOverdueBanner from 'components/root/payment_overdue_banner';
import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';
const EXCLUDED_LOCATIONS = [Floorboard, ForgotPassword, UserActivation, UserLogin, UserResetPassword];

export function TopBar({ currentLocation }) {
  const isFeatureEnabled = useIsFeatureEnabled();
  const isPaymentOverdueBannerVisible = isFeatureEnabled('paymentOverdueBanner');
  const isPhone = useDevice() === Device.Phone;
  const isCustomerView = currentLocation instanceof CustomerView;
  const isInbox = currentLocation instanceof Inbox;

  if (_.some(EXCLUDED_LOCATIONS, excludedLocation => currentLocation instanceof excludedLocation)) {
    return null;
  }

  if (isPhone && isCustomerView) {
    return (
      <TopBarStyled $isPaymentOverdueBannerVisible={isPaymentOverdueBannerVisible} data-aid="topBar">
        <PaymentOverdueBanner />
        <MobileCustomerHeader />
      </TopBarStyled>
    );
  }

  if (isPhone && !isInbox) {
    return (
      <TopBarStyled $isPaymentOverdueBannerVisible={isPaymentOverdueBannerVisible} data-aid="topBar">
        <PaymentOverdueBanner />
        <MobileBackHeader />
        <TopBarContent />
      </TopBarStyled>
    );
  }

  return (
    <TopBarStyled $isPaymentOverdueBannerVisible={isPaymentOverdueBannerVisible} data-aid="topBar">
      <PaymentOverdueBanner />
      <HamburgerSpacer />
      <BackButtonContainer />
      <TopBarContent />
    </TopBarStyled>
  );
}

TopBar.propTypes = {
  currentLocation: PropTypes.any,
  isPaymentOverdueBannerVisible: PropTypes.bool,
};

const HamburgerSpacer = styled.div`
  width: 50px;
`;

const TopBarStyled = styled.div`
  background-color: ${p => p.theme.colors.white};
  box-shadow: ${p => p.theme.boxShadow.medium};
  display: flex;
  height: 60px;
  position: fixed;
  top: ${p => (p.$isPaymentOverdueBannerVisible ? '36px' : '0')};
  width: 100%;
  z-index: 7;

  [data-device='phone'] & {
    padding: 0 8px;
  }
`;

function mapStateToProps({ getProvider }) {
  return {
    currentLocation: getProvider('currentLocation').get(),
  };
}

const TopBarContainer = connect(mapStateToProps)(TopBar);
export default TopBarContainer;
